/**
 * Raster tiles aligned with `apps/app` default map layer (`src/utils/map/layer.js`).
 * MapTiler Streets @2x, 512px tiles.
 */

/** Opt-in: set `VITE_MAP_SHOW_ATTRIBUTION=true` to show Leaflet/Mapbox on-map attribution (providers default to hidden). */
export function isMapAttributionVisible(): boolean {
  return import.meta.env.VITE_MAP_SHOW_ATTRIBUTION === 'true';
}

export const APP_MAP_TILE_URL =
  'https://api.maptiler.com/maps/streets/{z}/{x}/{y}@2x.png?key=9itgsP62snlBhRn8G4sH';

/** MapTiler satellite raster (same API key as {@link APP_MAP_TILE_URL}). */
export const APP_MAP_SATELLITE_TILE_URL =
  'https://api.maptiler.com/maps/satellite/{z}/{x}/{y}@2x.jpg?key=9itgsP62snlBhRn8G4sH';

/** Leaflet options required for correct alignment with 512px MapTiler tiles. */
export const APP_MAP_TILE_OPTIONS = {
  maxZoom: 20,
  tileSize: 512,
  zoomOffset: -1,
  minZoom: 1,
} as const;

export function getAppMapTileAttribution(): string {
  if (!isMapAttributionVisible()) return '';
  return '© <a href="https://www.maptiler.com/copyright/">MapTiler</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
}

export function getAppMapTileUrl(): string {
  return APP_MAP_TILE_URL;
}
